import { searchLinks } from './PaymentLinksApi';

export default (
  paymentLinksResponseMap: Awaited<ReturnType<typeof searchLinks>> | null
) =>
  paymentLinksResponseMap
    ? paymentLinksResponseMap.results.map((paymentLink) => ({
        value: paymentLink.id,
        ...paymentLink,
      }))
    : [];
